const SITEBAR_HEIGHT = 50;

export function anchorLinkOffset(): void {
  window.addEventListener('hashchange', () => {
    if (location?.hash?.length !== 0) {
      window.scrollTo(window.scrollX, window.scrollY - SITEBAR_HEIGHT - 5);
    }
  });
}


export const scrollToPostId = (postId: string): void => {
  const postToScroll = document.getElementById(`post-resp-${postId}`);
  if (postToScroll) {
    setTimeout(() => {
      window.scrollTo({
        behavior: 'smooth',
        top: postToScroll.offsetTop - 60,
      });
    }, 500);
  }
};

export const scrollToElementId = (id: string, timeout?: number): void => {
  const elementToScroll = document.getElementById(id);
  if (elementToScroll) {
    setTimeout(() => {
      window.scrollTo({
        behavior: 'smooth',
        top: elementToScroll.offsetTop - 60,
      });
    }, timeout ?? 500);
  }
};

export const scrollToResponses = (): void => {
  const responsesEl = document.getElementById('post-responses');
  if (responsesEl) {
    setTimeout(() => {
      window.scrollTo({
        behavior: 'smooth',
        top: responsesEl.offsetTop - 70,
      });
    }, 50);
  }
};

export function scrollIntoView(element: HTMLElement | Element | null): void {
  if (!element) return;
  element.scrollIntoView({ behavior: 'smooth', block: 'center' });
}
